const Theme = {
    body_background_color: '#FFF',

    logo_image_url: 'infrastructuresqds.png',
    logo_height: 110,

    button_color: '#E2001A',
    button_text_uppercase: true,
    button_radius: '25',
    button_width: '300',
    button_centered: true,

    button_half_border_color: '#E2001A',

    text_font: `'Titillium Web', sans-serif`,

    title_font: `'M PLUS Rounded 1c', sans-serif`,
    title_uppercase: true,

    subtitle_font: `'M PLUS Rounded 1c', sans-serif`,
  }

  export default Theme
